export const styles = (theme) => ({
  root: (props) => {
    const gutterTopExtended = props.gutterTopExtended ? theme.spacing(4) : 0;
    const gutterTop = props.gutterTop
      ? theme.spacing(4) + gutterTopExtended
      : 0;
    return {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      maxWidth: props.fullWidth ? '100%' : 1264,
      paddingTop: gutterTop,
      paddingBottom: props.gutterBottom ? theme.spacing(4) : 0,
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
      [theme.breakpoints.up('lg')]: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
      },
    };
  },
});
